/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailNotificationResponse
 */
export interface EmailNotificationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof EmailNotificationResponse
     */
    isSent?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EmailNotificationResponse
     */
    message?: string | null;
}

/**
 * Check if a given object implements the EmailNotificationResponse interface.
 */
export function instanceOfEmailNotificationResponse(value: object): value is EmailNotificationResponse {
    return true;
}

export function EmailNotificationResponseFromJSON(json: any): EmailNotificationResponse {
    return EmailNotificationResponseFromJSONTyped(json, false);
}

export function EmailNotificationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailNotificationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isSent': json['isSent'] == null ? undefined : json['isSent'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function EmailNotificationResponseToJSON(json: any): EmailNotificationResponse {
    return EmailNotificationResponseToJSONTyped(json, false);
}

export function EmailNotificationResponseToJSONTyped(value?: EmailNotificationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSent': value['isSent'],
        'message': value['message'],
    };
}

